import axios from "../request";

//获取列表
export function getSwipeCommissionTemplate(data) {
  return axios.request({
    url: "api/SwipeCommission",
    method: "get",
    params: data,
  });
}
//新增
export function addSwipeCommissionTemplate(data) {
  return axios.request({
    url: "api/SwipeCommission",
    method: "post",
    data: data
  });
}

//删除
export function delSwipeCommissionTemplate(id) {
  return axios.request({
    url: "api/SwipeCommission/"+id,
    method: "delete"
  });
}

//修改
export function updateSwipeCommissionTemplate(id, data) {
  return axios.request({
    url: "api/SwipeCommission/"+id,
    method: "put",
    data: data
  });
}
//获取明细列表
export function getSwipeCommissionDetail(id) {
  return axios.request({
    url: "api/SwipeCommission/GetDetailById/"+id,
    method: "get"
  });
}
//新增明细
export function addSwipeCommissionDetail(data) {
  return axios.request({
    url: "api/SwipeCommission/DetailAdd",
    method: "post",
    data: data
  });
}

//删除明细
export function delSwipeCommissionDetail(id) {
  return axios.request({
    url: "api/SwipeCommission/DetailDel/"+id,
    method: "delete"
  });
}

//修改明细
export function updateSwipeCommissionDetail(id, data) {
  return axios.request({
    url: "api/SwipeCommission/DetailUpdate/"+id,
    method: "put",
    data: data
  });
}
